module.exports = __webpack_public_path__ + "img/invoice-green.05198cb0.svg";